module.exports = __webpack_public_path__ + "static/media/back.6c502bd2.svg";